const updateUserAccessBySuperadmin = {
  toastr: 'Updated User',
  toastr1: ' has been updated successfully',
  toastrError: 'Name already registered',
  toastrError: 'Enter another name'
};

export default updateUserAccessBySuperadmin;
